export const tableStatics = {
    title: "لایسنس ها",
    description: "",
    addNewItemButtonLink: '/'
}
export const formStatics = {
    title: "درخواست سفارش کد",
    editTitle: "ویرایش لایسنس",
    description: "از اینجا میتوانید اقدام به خرید لایسنس کنید",
    editDescription: "از اینجا میتوانید اقدام به ویرایش لایسنس کنید",
    submitText: "خرید لایسنس",
    editSubmitText: "ویرایش لایسنس",
}


export const EmptyStateObject = {
    title: "درخواست در پایگاه داده یافت نشد",
    content: "در صورتی که درخواست سفارش کد دارید، از تب فرم سفارش، سفارش خود را ثبت کنید",
    buttonText: "ثبت سفارش",
    buttonOnClickUrl: "/request-order-new-strategy-code"
}


export const TableActionsStructure = [
    {
        title: "خرید اکانت جدید",
        link: '/plans'
    }
]
export const filterStructure = [
    {
        title: "نام کاربری",
        slug: 'username',
        type: "text",
    },
    {
        title: "پسورد",
        slug: 'password',
        disabled: true,
        type: "text",
    },
    {
        title: "انوستور",
        slug: 'investor',
        disabled: true,
        type: "text",
    },
    {
        title: "سرور",
        slug: 'server',
        disabled: true,
        type: "text",
    },
    {
        title: "بالانس",
        slug: 'balance',
        disabled: true,
        type: "text",
    },
    {
        title: "وضعیت",
        slug: 'status',
        disabled: true,
        type: "select",
        options: [
            {label: 'فعال', value: 'beginner'},
            {label: 'غیر فعال', value: 'professional'},
        ],
    },
]

export const tableStructure = [
    {
        title: "شماره سفارش",
        slug: 'orderNumber',
        useFarsiNumber: true
    },
    {
        title: "ایمیل",
        slug: 'user.email',
    },
    {
        title: "وضعیت",
        slug: 'status',
        useTranslate: true
    },
    {
        title: "تاریخ",
        slug: 'createdAt',
        useJalaliFormat: true,
        useFarsiNumber: true
    },
    {
        title: "قابل پرداخت (ریال)",
        slug: 'amount',
        useMoneySeparator: true,
        useFarsiNumber: true
    },
    {
        title: "عملیات",
        useActionsButton: true, //use delete-item class to automatic implement the removing item.
        slug: '',
        actions: [
            {
                title: "بررسی درخواست",
                slug: "review-order",
                useRoute: true,
                route: "/app/ecommerce/order/review/request-order-new-code/:_id"
            },
        ]
    },
]


